import { swipeContractorList, swipeEmployeeList, swipeList } from "../../actionCreators/screen/screen";
import { call, put, takeEvery } from "redux-saga/effects";
import ScreenService from "../../../services/screen/screen";
import { GET_SWIPE_CONTRACTOR_WATCHER, GET_SWIPE_EMPLOYEE_WATCHER, GET_COUNTER_ADMIN_WATCHER } from "../../actionTypes/screen";
import { updateFalseLoader, updateOpenLoader } from "../../actionCreators/spinner";
import { updateAlert } from "../../actionCreators/alert";
import { errorMessage } from "../../../utils/errorMessage";


function* getContractorEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(ScreenService.getContractor, action.payload);
    yield put(swipeContractorList(data.recordset));
    yield put(updateFalseLoader());
    //yield put(updateAlert('Success', 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(errorMessage(e, 'Something Went Wrong!'), 'error'));
  }
}

function* getEmployeeEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(ScreenService.getEmployee, action.payload);
    yield put(swipeEmployeeList(data.recordset));
    yield put(updateFalseLoader());
    //yield put(updateAlert('Success', 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(errorMessage(e, 'Something Went Wrong!'), 'error'));
  }
}

function* getCounterAdminEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(ScreenService.getSwipeData, action.payload);
    yield put(swipeList(data.recordsets));
    yield put(updateFalseLoader());
    //yield put(updateAlert('Success', 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(errorMessage(e, 'Something Went Wrong!'), 'error'));
  }
}

//saga 
export const SwipeSaga = [
  takeEvery(GET_SWIPE_CONTRACTOR_WATCHER, getContractorEffect),
  takeEvery(GET_SWIPE_EMPLOYEE_WATCHER, getEmployeeEffect),
  takeEvery(GET_COUNTER_ADMIN_WATCHER, getCounterAdminEffect),
]
